/**
 * Inline SVG flag component using country-flag-icons library.
 * Renders a clean SVG (no images), color-accurate.
 */
import * as Flags from "country-flag-icons/react/3x2";

export default function Flag({ country, className = "", title }) {
    const cc = (country || "").toUpperCase();
    const Component = Flags[cc];
    if (!Component) {
        // Fallback: empty rectangle with the country code
        return (
            <span
                className={`inline-flex items-center justify-center rounded-[2px] bg-muted text-[8px] font-semibold text-muted-foreground ${className}`}
                title={title || cc}
                style={{ width: "1.4em", height: "1em" }}
            >
                {cc || "?"}
            </span>
        );
    }
    return (
        <Component
            title={title || cc}
            className={`inline-block rounded-[2px] ring-1 ring-black/5 ${className}`}
            style={{ width: "1.4em", height: "1em", objectFit: "cover" }}
        />
    );
}
